import { createApp } from 'vue';
import SevenZipToIsoConverter from '@/Components/SevenZipToIsoConverter.vue';
import '@styles/app.css';

createApp(SevenZipToIsoConverter).mount('#sevenzip-to-iso-converter');
